import { defineMessages } from 'react-intl';

export const USE_CASE_TASK_MANAGER_GROUP = 'useCases';

export const messages = defineMessages({
  signUpOrLogInForPremium: {
    id: 't.signUpOrLogInForPremium',
    defaultMessage: 'You need to sign up or log in to listen to this {sourceType}.',
  },
});
